import * as store from '@attain-apps/fe/web/main/lib/store'
import { TypeAsserter } from '@attain-apps/type-guards'
import * as rxjs from 'rxjs'

import type { Api } from '../../api'
import type { Collection } from '../../collection'
import type { Feature } from '../feature'

import { concurrentByConnector } from './concurrent-by-connector'

/** Runs different connectors concurrently and suppresses duplicate active runs. */
export const executeRun = store.effects.create(
  (feature: Feature, collection: Collection, api: Api) =>
    concurrentByConnector(
      feature.actions.run.request.observe(),
      action => action.data.connectorId,
      action => {
        const context = collection.feature.selectors.context.asSignal()
        TypeAsserter.assertIsNotNullish(context)
        return api.run(context, action.data).pipe(
          rxjs.map(response => {
            if (response !== true) {
              throw new Error('Connector run did not complete successfully')
            }
            return feature.actions.run.success.from(action).create({
              request: action.data,
              response,
            })
          }),
          rxjs.catchError((error: Error) =>
            rxjs.of(
              feature.actions.run.error.from(action).create({
                error,
                request: action.data,
              }),
            ),
          ),
        )
      },
    ),
)
